var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"guide-main"},[_c('el-tooltip',{attrs:{"effect":"light","placement":"bottom","content":"引导"}},[_c('svg-icon',{attrs:{"icon-class":"guide"},on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.guide.apply(null, arguments)}}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }